
Object.assign({}, {});
[].find((d)=> {d});
[].findIndex((d)=> {d});
